<script>
import axios from 'axios'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import {
  infoDetailsMethods,
  actionsMethods,
  deviceCycleComputed,
  deviceEventCurrentMethods,
} from '@state/helpers'
import toggle from '@utils/design/toggle-info'

export default {
  components: {
    VuePerfectScrollbar,
  },

  props: {
    deviceEventCurrent: {
      type: Object,
      default: () => {},
    },
  },

  data: function() {
    return {
      search: '',
      settings: {
        maxScrollbarLength: 60,
      },
    }
  },

  computed: {
    ...deviceCycleComputed,

    filteredCycles: function() {
      return this.cachedCycles.filter((cycle) => {
        if (this.search.length > 0) {
          return cycle.name.toLowerCase().includes(this.search.toLowerCase())
        } else {
          return this.cachedCycles
        }
      })
    },
  },

  methods: {
    ...infoDetailsMethods,
    ...actionsMethods,
    ...deviceEventCurrentMethods,

    updateCycle(cycleName) {
      axios
        .post('/api/services/app/DeviceEvent/Create', {
          deviceId: this.deviceEventCurrent.deviceId,
          cycleName: cycleName,
        })
        .then((response) => {
          this.fetchEventCurrents({ clearCache: true })
            .then(() => {
              toggle()
            })
            .catch((error) => {
              if (error.response && error.response.status === 401) {
                this.$router.push({
                  name: 'Login',
                  params: { resource: 'Interact Cycle' },
                })
              }
              return null
            })
        })
    },
  },
}
</script>

<template>
  <div>
    <b-card-body
      v-if="deviceEventCurrent"
      class="animated fadeIn card info-card pt-2 mb-0 p-0 pb-3 clearfix"
    >
      <b-row class="ml-0 mr-0 device-info-row">
        <b-col class="h5 pl-3 mb-0 text-uppercase pt-1">
          {{ deviceEventCurrent.device.name }}
          <span class="clearfix">{{ deviceEventCurrent.cycle.name }}</span>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body
      class="card list-group card-body info-card  mb-0 pl-0 pr-0 pt-2 pb-2 clearfix"
    >
      <b-form-group class="filter">
        <label for="name" class="w-100 font-weight-bold text-uppercase text-muted"
          >Search by Cycle Name</label
        >
        <b-form-input
          v-model="search"
          class=" mb-2"
          placeholder="Cycle Name..."
          type="text"
        ></b-form-input>
      </b-form-group>

      <VuePerfectScrollbar
        class="scroll-area "
        style="min-height: 72vh;"
        :settings="settings"
      >
        <button
          v-for="cycle in filteredCycles"
          :key="cycle.id"
          type="button"
          class="list-group-item list-group-item-action text-uppercase"
          @click="updateCycle(cycle.name)"
        >
          {{ cycle.name }}
        </button>
      </VuePerfectScrollbar>
    </b-card-body>
  </div>
</template>

<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: 300px;
  width: 100%;
}

.card-body-side {
  border-radius: 0px !important;
}
.tab-content {
  border-radius: 0px !important;
}
</style>
